// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605060803/js/" + chunkId + "." + {"44":"f938b76f","225":"1104d426","481":"38380a03","486":"c9720370","770":"85ad19d1"}[chunkId] + ".0.310206078917294.chunk.js";
};